import React from "react";
import styled from "styled-components";
import { mixinSkins } from "../../../../../skins/shared/mixins/themeStyles";
import { SkinId } from "../../../../../skins/types";
import { riotProductSkin } from "../skins/riot-product";
import { BetaSpinner } from "./BetaSpinner";
const StylableBetaLoader = ({ className, children, isLoading, isAllowedRoute, }) => {
    return (React.createElement("div", { className: className },
        isLoading && (React.createElement("div", { style: { position: isAllowedRoute ? "fixed" : "relative" }, className: "beta-loader-container" }, BetaSpinner)),
        isAllowedRoute && children));
};
export const BetaLoader = styled(StylableBetaLoader) `
  ${mixinSkins({
    [SkinId.RiotProduct]: riotProductSkin,
})}
`;
//# sourceMappingURL=BetaLoader.js.map